/**
 * React Query hook: ping service-mail's /v1/health/ready endpoint.
 *
 * Phase-0 hand-rolled fetch. Once libs/shared/contracts is wired in (Phase 1),
 * this hook switches to the typed `openapi-fetch` client generated from
 * apps/service-mail/openapi.yaml.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { env } from '../../../lib/env';

export interface MailHealth {
  ok: boolean;
  service: string;
  version: string;
}

async function fetchMailHealth(): Promise<MailHealth> {
  const res = await fetch(`${env.serviceMailBaseUrl}/v1/health/ready`, {
    headers: { accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`service-mail responded ${res.status}`);
  }
  const body = (await res.json()) as Partial<MailHealth>;
  if (typeof body.ok !== 'boolean' || typeof body.service !== 'string' || typeof body.version !== 'string') {
    throw new Error('service-mail returned malformed health payload');
  }
  return { ok: body.ok, service: body.service, version: body.version };
}

export function useMailHealth(): UseQueryResult<MailHealth, Error> {
  return useQuery({
    queryKey: ['service-mail', 'health', 'ready'],
    queryFn: fetchMailHealth,
    staleTime: 10_000,
  });
}
